//Master Reporting Action Types

//Get List of Master Reporting Items
export const GET_MASTER_REPORTING_ITEMS = "GET_MASTER_REPORTING_ITEMS";
export const GET_MASTER_REPORTING_ITEMS_SUCCESS =
  "GET_MASTER_REPORTING_ITEMS_SUCCESS";
export const GET_MASTER_REPORTING_ITEMS_FAILURE =
  "GET_MASTER_REPORTING_ITEMS_FAILURE";
